import getClientContact from "@/mixins/getClientContact";
import { mapGetters } from "vuex";
import replacementService from "@/services/replacement";
import Utils from "@/mixins/Utils";

export default {
  mixins: [getClientContact, Utils],
  props: ["limit"],

  data: () => ({
    replacements: [],
    errorMission: false,
    showGoogleMap: true,
    googleApiKey: window.configs && window.configs.VUE_APP_GOOGLE_API_KEY !== "" 
    ? window.configs.VUE_APP_GOOGLE_API_KEY: process.env.VUE_APP_GOOGLE_API_KEY,
    noInformation: "Non renseigné",
    // pkReplacementStatus: [
    //   { value: 0, label: "Non renseigné" },
    //   { value: 1, label: "En cours" },
    //   { value: 2, label: "Pourvue" },
    //   { value: 3, label: "Annulée" },
    // ],
    // pkIxCrfReplacementRequest: [
    //   { value: 0, label: "Non renseigné" },
    //   { value: 1, label: "En Attente" },
    //   { value: 2, label: "Accepté" },
    //   { value: 3, label: "Refusé" },
    //   { value: 4, label: "Validé" },
    //   { value: 5, label: "Supprimé" },
    // ],
    pkReplacementStatuses: {
      NO_INFO: 0,
      IN_PROGRESS: 1,
      PROVIDED: 2,
      CANCELLED: 3,
    },
    pkIxCrfReplacementRequests: {
      NO_INFO: 0,
      PENDING: 1,
      ACCEPT: 2,
      REFUSE: 3,
      VALIDATED: 4,
      DELETED: 5,
    },
    messageAdv: undefined
  }),
  computed: {
    ...mapGetters({
      spinnerMission: "isLoading",
    }),
  },

  async created() {
    await this.getRequests();
  },
  methods: {
    getReplacementStatus(status) {
      const vm = this;
      switch (status) {
        case vm.pkReplacementStatuses.NO_INFO:
          return "Non renseigné";
        case vm.pkReplacementStatuses.IN_PROGRESS:
          return "En cours";
        case vm.pkReplacementStatuses.PROVIDED:
          return "Pourvue";
        case vm.pkReplacementStatuses.CANCELLED:
          return "Annulée";
      }
    },
    getReplacementRequest(status) {
      const vm = this;
      switch (status) {
        case vm.pkIxCrfReplacementRequests.NO_INFO:
          return "Non renseigné";
        case vm.pkIxCrfReplacementRequests.PENDING:
          return "En Attente";
        case vm.pkIxCrfReplacementRequests.ACCEPT:
          return "Accepté";
        case vm.pkIxCrfReplacementRequests.REFUSE:
          return "Refusé";
        case vm.pkIxCrfReplacementRequests.VALIDATED:
          return "Validé";
        case vm.pkIxCrfReplacementRequests.DELETED:
          return "Supprimé";
      }
    },
    async getRequests() {
      const vue = this;
      await replacementService
        .getRequests()
        .then((res) => {
          if (res.success) {
            vue.replacements = res.data.map((m) => {
              return {
                ...m,
                clientName: null,
                isShowDescription: false,
                isShowComment: false,
              };
            });
            vue.replacements.forEach(async (replacement) => {
              const clientContact = await vue.getClient(
                replacement.pkCrfClient
              );
              replacement.clientName = clientContact
                ? clientContact.name
                : vue.$t("no-information");
              replacement.clientAddress = clientContact
                ? clientContact.address
                : vue.$t("no-information")
            });
            // vue.replacements = Promise.all(promises);
            vue.errorMission = false;
            return;
          }
          vue.replacements = [];
          vue.errorMission = true;
        })
        .catch((err) => {
          vue.replacements = [];
          vue.errorMission = true;
        });
    },
    getStaticMapURL(mission) {
      return `https://maps.google.com/maps/api/staticmap?
        center=${mission.lat},${mission.lng}
        &size=365x256&scale=1&sensor=false&zoom=16
        &markers=${mission.lat}%2C${mission.lng}
        &key=${this.googleApiKey}`;
    },
    async approve(replacement) {
      const vm = this;
      let validate;
      await this.$validator.validate("messageAdv", this.messageAdv).then((result) => {
        validate = result
      })
      if (!validate) {
        this.callToaster(
          this.$t('replacement-view-messageAdv-required')
        );
        return;
      }
      const value = await this.$bvModal.msgBoxConfirm(this.$t('replacement-page-confirm-aceept'), {
        title: 'Veuillez confirmer',
        size: 'md',
        buttonSize: 'sm',
        okTitle: 'OUI',
        okVariant: 'primary',
        cancelTitle: 'NON',
        cancelVariant: 'primary',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      if (value) {
        replacementService
          .createRequest(replacement.id, { message: vm.messageAdv })
          .then(function(response) {
            if (response.success) {
              replacement.pkIxCrfReplacementRequest = vm.pkIxCrfReplacementRequests.ACCEPT;
              vm.callToaster(
                vm.$t('replacement-page-successfull-apply')
              );
            }
          })
          .catch(function(error) {
            vm.callToaster(
              vm.$t('replacement-page-error-apply')
            );
          });
      }
    },
    async refuse(replacement) {
      const vm = this;
      let validate;
      await this.$validator.validate("messageAdv", this.messageAdv).then((result) => {
        validate = result
      })
      if (!validate) {
        this.callToaster(
          this.$t('replacement-view-messageAdv-required')
        );
        return;
      }
      const value = await this.$bvModal.msgBoxConfirm(this.$t('replacement-page-confirm-delete'), {
        title: 'Veuillez confirmer',
        size: 'md',
        buttonSize: 'sm',
        okTitle: 'OUI',
        okVariant: 'primary',
        cancelTitle: 'NON',
        cancelVariant: 'primary',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
      if (value) {
        replacementService
          .deleteRequest(replacement.id, { message: vm.messageAdv })
          .then(function(response) {
            if (response.success) {
              replacement.pkIxCrfReplacementRequest = vm.pkIxCrfReplacementRequests.REFUSE;
              vm.callToaster(
                vm.$t('replacement-page-successfull-delete')
              );
            }
          })
          .catch(function(error) {
            vm.callToaster(
              vm.$t('replacement-page-successfull-delete')
            );
          });
      }
    },
  },
};
